import { Component, OnInit, OnDestroy } from "@angular/core";
import { SidebarService } from "@ibe/services/ui";
import { ActivatedRoute, Router } from "@angular/router";
import { INDRABookingService } from "@ibe.services/booking.indra.service";
import {
	ANCILLARY_PRODUCT_GROUP_CODE_HOLD_BAGGAGE,
	TRANSLATION_ANCILLARY_DETAILED,
	TRANSLATION_ANCILLARY_GROUP,
	ANCILLARY_GROUP_HOLD_BAGGAGE_LIST,
	BRAND_DESCRIPTION_TOP_EXECUTIVE,
	BRAND_DESCRIPTION_EXECUTIVE,
	COUNTRY_USA,
	PAX_TYPE_INFANT_CODE,
	CHECKED_BAGGAGE_FOR_INFANT_TRANSLATION_KEY,
	CHECKED_BAGGAGE_ANCILLARY_CODES,
	SSR_CODE_BAGGAGE_PRIORITY,
	ANCILLARY_GROUP_DEPORTEES_LIST,
	ANCILLARY_GROUP_MEDICAL_ASSISTANCE_LIST,
	SSR_CODE_UNACCOMPANIED_MINOR,
	SSR_CODE_BAGGAGE_ADDITIONAL_BAG,
	SSR_CODE_BAGGAGE_FIRST_BAG,
	SSR_CODE_BAGGAGE_SECOND_BAG,
	EXTRAS_ANCILLARY_BAG,
	COUNTRY_CODE_USA,
	TIER_ECONOMY_BAGGAGE,
	TIER_BUSINESS_BAGGAGE,
	BRAND_NAMES_MAP,
	SESSION_VAR_KEY_LANGUAGE,
	DEFAULT_LANGUAGE,
	SESSION_VAR_KEY_MARKET,
	DEFAULT_MARKET,
	SPECIAL_CASE_MARKET_LANGUAGE_MAP
} from "@ibe.config";
import { INDRAPax } from "@ibe.models/pax.indra.model.lib";
import { INDRAIbeAdminService } from "@ibe.services/ibeadmin.indra.service";
import { INDRASegment } from "@ibe.models/segment.indra.model.lib";
import { INDRAIncludedAncillaryCodeCount, INDRAIncludedAncillaryDetailForSegment } from "@ibe.models/ancillary.indra.model.lib";
import { HttpClient } from "@angular/common/http";
import { INDRALocationService } from "@ibe.services/location.indra.service";
import { INDRABFMDataStorageService } from "@ibe.services/bfm-data-storage.indra.service";
import { INDRAAncillariesShoppingCartService } from "@ibe.services/ancillaries-shopping-cart.indra.service";
import { INDRATotalSummaryService } from "@ibe.services/total-summary.service";
import { INDRABookingSearchService } from '@ibe.services/booking-search.indra.service';
import { Subscription } from "../../../../../../../node_modules/rxjs";
import { INDRAIbeAdminConfigService } from "@ibe.services/ibeadmin-config.service";

@Component({
	selector: 'app-details-luggage',
	templateUrl: './details-luggage.indra.component.html',
	styleUrls: ['./details-luggage.component.scss']
})
export class INDRADetailsLuggageComponent implements OnInit, OnDestroy {

	private flightIdentifier: string;
	flight: any;
	flightRouteInput: any;
	_hasEdit = true;
	paxFareInfoFeatures = [];
	paxPriorityFareInfoFeatures = [];
	paxPurchaseFeatures = [];

	passengers: INDRAPax[] = [];

	countUnit = '';
	hasLayover = false;
	usAirports;
	segmentSelected = 1;
	isUs: boolean = false;
	countries = [
		COUNTRY_USA
	]
	isInfantPassengerIncluded = false;

	hasDeporteeFlag = false; // this will be utilized for detecting deportee/under lawful custody ancillary on prm
	hasMedicalAssistanceFlag = false; // this will be utilized for detecting requested medical assistance on prm
	hasUMNRFlag = false; // this will be utilized for detecting if unaccompnied minor SSR was included on prm
	hasWarning = false; // this will be a flag for displaying warning messages on the sidebar
	IfAllPassengersAreChildren = false;
	hasIssuedTicket = true; // used for checking if PNR has issued ticket/s
	showAddButton: boolean = true;
	countryCodes = [
		COUNTRY_CODE_USA
	];
	paxTierAncillary = [];
	ancillaryGroup: string;
	isFlagged: boolean = false;
	totalSummarySubscription: Subscription;
	
	isMYB: boolean = false;
	isBookingView: boolean = false;
	isReviewTTTCompletion: boolean = false;
	brandDescription: string;

	constructor(
		protected sidebarService: SidebarService,
		protected route: ActivatedRoute,
		protected router: Router,
		protected bookingService: INDRABookingService,
		private ibeAdminService: INDRAIbeAdminService,
		protected _http: HttpClient,
		private locationService: INDRALocationService,
		private bfmDataStorage: INDRABFMDataStorageService,
		public ancillaryCartService: INDRAAncillariesShoppingCartService,
		private totalSummaryService: INDRATotalSummaryService,
		private bookingSearchService: INDRABookingSearchService,
		private ibeAdminConfigService: INDRAIbeAdminConfigService
	) { 
		if (this.router.url.includes('/my-bookings/')) this.isMYB = true;
		if (this.router.url.includes('/my-bookings/view/')) this.isBookingView = true;
		if (this.router.url.includes('/review-your-trip/deeplink/')) this.isReviewTTTCompletion = true;
	}

	ngOnInit() {
		this.flightIdentifier = this.route.snapshot.paramMap.get('flight');
		this.flight = this.bookingService.INDRA_getBookedFlight(this.flightIdentifier);
		this.flightRouteInput = this.bookingService.INDRA_getFlightRoute(this.flight);
		this.brandDescription = this.INDRA_getBrandDescription();
		this.passengers = this.bookingService.INDRA_getPaxInfo();
		this.hasLayover = this.INDRA_checkIndirectFlight();
		this.ancillaryGroup = ANCILLARY_PRODUCT_GROUP_CODE_HOLD_BAGGAGE;
		this.IfAllPassengersAreChildren = this.bookingService.INDRA_checkIfAllPassengersAreChildren(this.passengers);
		this.INDRA_checkIfSpecialCaseCountry(); /** Checks if US flight */
		this.hasIssuedTicket = this.bookingService.INDRA_checkIfPNRIssuedTickets();
		let fareInfoAncillary = this.bookingService.INDRA_getPassengersAncillaryFareInformation(ANCILLARY_PRODUCT_GROUP_CODE_HOLD_BAGGAGE, this.flight.idFlight.toString());
		// let purchasedAncillary = this.bookingService.INDRA_getPassengersPurchasedAncillary(ANCILLARY_PRODUCT_GROUP_CODE_HOLD_BAGGAGE, this.flight.idFlight.toString(), this.flightIdentifier);
		let purchasedAncillaryWithSegmentInfo = this.bookingService.INDRA_getPassengersPurchasedAncillaryWithSegmentInfo(ANCILLARY_PRODUCT_GROUP_CODE_HOLD_BAGGAGE, this.flight.idFlight.toString(), this.flightIdentifier);

		this.passengers.forEach(pax => {
			const fareInfoindex = fareInfoAncillary.findIndex(
				object => object[pax.idPax]
			);
			let paxfareAncillaries = fareInfoAncillary[fareInfoindex];
			let notPriorityBags: any = {};
			let priorityBags: any = {};
			notPriorityBags[pax.idPax] = []
			priorityBags[pax.idPax] = [];
			paxfareAncillaries[pax.idPax].forEach(
				(paxFareAncillary) => {
					if (paxFareAncillary !== SSR_CODE_BAGGAGE_PRIORITY) {
						notPriorityBags[pax.idPax].push(paxFareAncillary);
					} else {
						priorityBags[pax.idPax].push(paxFareAncillary);
					}
				});
			const tierAncillaries = this.bookingService.INDRA_getPassengersTierBenefits(ANCILLARY_PRODUCT_GROUP_CODE_HOLD_BAGGAGE);
			tierAncillaries.forEach((ancillary) => {
				Object.keys(ancillary).forEach((secondKey) => {
					if (secondKey == pax.idPax.toString()) {
						this.paxTierAncillary.push({ [pax.idPax]: this.INDRA_constructAncillaryByTier(ancillary[secondKey])});
					}
				});
			});
			this.paxFareInfoFeatures.push({
				[pax.idPax]: this.INDRA_constructAncillaryList(notPriorityBags[pax.idPax], pax.typePax)
			});
			this.paxPriorityFareInfoFeatures.push({
				[pax.idPax]: this.INDRA_constructAncillaryList(priorityBags[pax.idPax], pax.typePax)
			});
			;
			const purchasedIndex = purchasedAncillaryWithSegmentInfo.findIndex(
				object => object[pax.idPax]
			);
			if (purchasedIndex === -1) {
				this.paxPurchaseFeatures.push({
					[pax.idPax]: []
				});
			} else {
				let paxpurchasedAncillaries = purchasedAncillaryWithSegmentInfo[purchasedIndex];
				this.paxPurchaseFeatures.push({
					[pax.idPax]: this.INDRA_constructAncillaryListForPurchased(paxpurchasedAncillaries[pax.idPax])
				});
				//sort ascending based on segmentID
				this.paxPurchaseFeatures.sort((first, second) =>  (Number(first.segmentId) > Number(second.segmentId) ? -1 : 1));
			}

			if (pax.prm) {
				let deporteePRM = pax.prm.filter(prmItem => ANCILLARY_GROUP_DEPORTEES_LIST.includes(prmItem.type));
				let medicalAssistancePRM = pax.prm.filter(prmItem => ANCILLARY_GROUP_MEDICAL_ASSISTANCE_LIST.includes(prmItem.type));
				let umnrPRM = pax.prm.filter(prmItem => SSR_CODE_UNACCOMPANIED_MINOR == prmItem.type);

				if (deporteePRM.length > 0) {
					this.hasDeporteeFlag = true;
				}

				if (medicalAssistancePRM.length > 0) {
					this.hasMedicalAssistanceFlag = true;
				}

				if (umnrPRM.length > 0) {
					this.hasUMNRFlag = true;
				}
			}
		});
		this.totalSummarySubscription = this.totalSummaryService.INDRA_getObservableTotalSummary().subscribe(
			data => {
				if (data) {
					this.isFlagged = this.bookingService.INDRA_isUnavailableFlight(this.flight.idFlight, data);
				}
			}
		);
		this.INDRA_showAddButton();
	}
	
	INDRA_gotoURL(key) {
		const languageCode = sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE) ?
								sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE).toLowerCase() : DEFAULT_LANGUAGE;
		const languageMap = SPECIAL_CASE_MARKET_LANGUAGE_MAP[languageCode] ? SPECIAL_CASE_MARKET_LANGUAGE_MAP[languageCode] : languageCode;
		const marketCode = sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE) ?
								sessionStorage.getItem(SESSION_VAR_KEY_MARKET).toLowerCase() : DEFAULT_MARKET;
		const urlIbeAdmin = this.ibeAdminConfigService.getConfigurationValue(key);
		const urlNavigate = urlIbeAdmin.replace('${lang}', `${languageMap}`).replace('${market}', `${marketCode}`);
		return window.open(urlNavigate);
	}

	INDRA_openExtraBagsSidebar() {
		this.sidebarService.openSidebar(['checked-bags', { flight: this.flightIdentifier }]);
	}

	/** Close sidebar and clear secondary route */
	private INDRA_closeSidebar() {
		this.sidebarService.closeSidebar();
		this.router.navigate([{ outlets: { sidebar: null } }]);
	}

	/** Handles close action intention **/
	INDRA_handleClose() { this.INDRA_closeSidebar(); }

	INDRA_constructAncillaryList(list: string[], paxType: string) {
		this.countUnit = this.INDRA_getTranslation('whatsIncludedSidebars.detailsLuggage.texts.countUnitSingular');
		let returnValue = '';
		let addedAncillaryForInfant: Array<string> = [];
		let extraBagCount = this.INDRA_countExtraBags(list);

		list.forEach(item => {
			/** Checks if the passenger is an infant and if the ancillary is included in checked baggage list.
			 *  If so, a checked baggage with a specific weight limit for infant will be displayed.
			*/

			// checks if the current passenger is an infant
			let isInfant = paxType === PAX_TYPE_INFANT_CODE;

			// used to check if there is an infant passenger
			this.isInfantPassengerIncluded = isInfant ? true : this.isInfantPassengerIncluded;
			let itemCode = CHECKED_BAGGAGE_ANCILLARY_CODES.includes(item) && isInfant ? CHECKED_BAGGAGE_FOR_INFANT_TRANSLATION_KEY : item;

			if (!isInfant || (isInfant && !addedAncillaryForInfant.includes(itemCode))) {
				if (itemCode == SSR_CODE_BAGGAGE_ADDITIONAL_BAG) {
					if (returnValue.length === 0) {
						returnValue = extraBagCount + ' ' + this.countUnit + ' ' + this.INDRA_getTranslation(`${TRANSLATION_ANCILLARY_DETAILED + itemCode}`);
					} else {
						returnValue = returnValue + ', ' + extraBagCount + ' ' + this.countUnit + ' ' + this.INDRA_getTranslation(`${TRANSLATION_ANCILLARY_DETAILED + itemCode}`);
					}
				}
				else {
					if (returnValue.length === 0) {
						returnValue = this.INDRA_getTranslation(`${TRANSLATION_ANCILLARY_DETAILED + itemCode}`);
					} else {
						returnValue = returnValue + ', ' + this.INDRA_getTranslation(`${TRANSLATION_ANCILLARY_DETAILED + itemCode}`);
					}
				}
			}

			/** Populate array of added ancillaries for infant */
			if (isInfant && !addedAncillaryForInfant.includes(itemCode)) {
				addedAncillaryForInfant.push(itemCode)
			}
		});

		return returnValue;
	}

	INDRA_constructAncillaryListForPurchased(list: any[]): INDRAIncludedAncillaryDetailForSegment[] {
		this.countUnit = this.INDRA_getTranslation('whatsIncludedSidebars.detailsLuggage.texts.countUnitSingular');
		let returnValue: INDRAIncludedAncillaryDetailForSegment[] = [];
		list.forEach(segment => {
			let descriptionForSegment = '';
			let priorityDescriptionForSegment = '';
			// flag for unconfirmed codes//
			let unconfirmed: boolean = false;
			let priorityUnconfirmed: boolean = false;
			let fbag = "";
			let sbag = "";
			let xbag = "";
			let others = "";
			segment.ancillaryList.forEach((ancillary: INDRAIncludedAncillaryCodeCount) => {
				if (ancillary.code !== SSR_CODE_BAGGAGE_PRIORITY) {
					// ANCILLARIES WARNING
					if (ancillary.unconfirmed) {
						unconfirmed = true;
						this.hasWarning = true;
					}
					if (ancillary.code == (SSR_CODE_BAGGAGE_FIRST_BAG)) {
						if (fbag.length === 0) {
							fbag = this.INDRA_getTranslation(`${TRANSLATION_ANCILLARY_DETAILED + ancillary.code}`);
						} else {
							fbag = fbag + ', ' + this.INDRA_getTranslation(`${TRANSLATION_ANCILLARY_DETAILED + ancillary.code}`);
						}
					}
					else if (ancillary.code == SSR_CODE_BAGGAGE_SECOND_BAG) {
						if (sbag.length === 0) {
							sbag = this.INDRA_getTranslation(`${TRANSLATION_ANCILLARY_DETAILED + ancillary.code}`);
						} else {
							sbag = sbag + ', ' + this.INDRA_getTranslation(`${TRANSLATION_ANCILLARY_DETAILED + ancillary.code}`);
						}
					}
					else if (ancillary.code == SSR_CODE_BAGGAGE_ADDITIONAL_BAG) {
						let xCount = this.INDRA_getTranslation('whatsIncludedSidebars.detailsLuggage.texts.countUnitPlural');
						if (ancillary.count == 1) {
							xCount = this.countUnit;
						}
						if (xbag.length === 0) {
							xbag = ancillary.count + ' ' + xCount + ' ' + this.INDRA_getTranslation(`${TRANSLATION_ANCILLARY_DETAILED + ancillary.code}`);
						} else {
							xbag = xbag + ', ' + ancillary.count + ' ' + xCount + ' ' + this.INDRA_getTranslation(`${TRANSLATION_ANCILLARY_DETAILED + ancillary.code}`);
						}
					} else {
						// direct from translation (ancillay codes with multipliers)
						others = this.INDRA_getTranslation(`${TRANSLATION_ANCILLARY_DETAILED + ancillary.code}`);
					}


				} else {
					priorityDescriptionForSegment = this.INDRA_getTranslation(`${TRANSLATION_ANCILLARY_DETAILED + ancillary.code}`);
					// ANCILLARIES WARNING
					if (ancillary.unconfirmed) {
						priorityUnconfirmed = true;
						this.hasWarning = true;
					}
				}
			});
			descriptionForSegment = (fbag.length !== 0 ? fbag : '') + ((sbag.length !== 0 || xbag.length !== 0) && fbag.length !== 0 ? ', ' : '') + (sbag.length !== 0 ? sbag : '') + (xbag.length !== 0 && (sbag.length !== 0) ? ', ' : '') + (xbag.length !== 0 ? xbag : '');
			if (others.length > 0) {
				descriptionForSegment.length === 0 ? (descriptionForSegment = others) : (descriptionForSegment = descriptionForSegment + ', ' + others);
			}

			returnValue.push({
				ancillaryDetail: descriptionForSegment,
				segmentId: segment.segmentId,
				// ANCILLARIES WARNING
				unconfirmed: unconfirmed
			});
			if (priorityDescriptionForSegment) {
				returnValue.push({
					ancillaryDetail: priorityDescriptionForSegment,
					segmentId: segment.segmentId,
					// ANCILLARIES WARNING
					unconfirmed: priorityUnconfirmed
				});
			}
		});
		return returnValue;
	}

	INDRA_constructAncillaryByTier(list: any[]) {
		let returnValue = '';
		let itemCode = '';
		list.forEach((item) => {
			if (item.length > 1) {
				if (this.flight.cabin) {
					itemCode = this.flight.cabin === 'Economy' ? TIER_ECONOMY_BAGGAGE : TIER_BUSINESS_BAGGAGE;
				}
				returnValue = this.INDRA_getTranslation(`${TRANSLATION_ANCILLARY_DETAILED + itemCode}`)
			}
		});
		return returnValue;
	}

	INDRA_displaySegmentInfo(segmentId: string) {
		let returnValue = '';
		if (this.hasLayover) {
			let segmentInfo: INDRASegment = this.bookingService.INDRA_getSegment(this.flightIdentifier, segmentId);
			let segmentDeparture = this.bookingService.INDRA_getLocation(segmentInfo.departureAirport);
			let segmentArrival = this.bookingService.INDRA_getLocation(segmentInfo.arrivalAirport);
			returnValue = ' ' + segmentDeparture.city + ' - ' + segmentArrival.city;
		}
		return returnValue;
	}

	INDRA_capitalize(str: string) {
		if (str.length > 0) {
			return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
		}
		return '';
	}

	INDRA_printPassengerName(pax: INDRAPax) {
		return this.INDRA_capitalize(pax.name) + ' ' + this.INDRA_capitalize(pax.surname);
	}

	INDRA_printBrand() {
		return this.brandDescription;
	}

	INDRA_getTranslation(key: string): string {
		return this.ibeAdminService.getTranslationValue(key);
	}

	INDRA_getAncillaryForPassenger(list: any, idPax: number) {
		let returnValue;
		const index = list.findIndex(
			item => Object.keys(item)[0] === idPax.toString()
		);
		if (list) {
			let paxAncillary = list[index];
			returnValue = paxAncillary[idPax];
			return returnValue;
		}

	}

	INDRA_getPurchasedAncillaryForPassenger(idPax: number): any[] {
		let returnValue = [];
		const index = this.paxPurchaseFeatures.findIndex(
			item => Object.keys(item)[0] === idPax.toString()
		);
		if (this.paxPurchaseFeatures) {
			let paxAncillary = this.paxPurchaseFeatures[index];
			// Sort the retrieve bag ancillaries by segmentId
			returnValue = this.bookingService.INDRA_sortBySegment(paxAncillary[idPax], this.flight);
			return returnValue;
		}
	}

	INDRA_getPurchasedAncillaryBySegment(idPax: number, segmentId: number) {
		let passengerPurchased = this.INDRA_getPurchasedAncillaryForPassenger(idPax);
		let returnValue = [];
		returnValue = passengerPurchased.filter(
			(item) => item.segmentId == segmentId
		);
		return returnValue;
	}

	INDRA_getGroupLabel() {
		let groupList: string[] = ANCILLARY_GROUP_HOLD_BAGGAGE_LIST;
		return this.INDRA_getTranslation(`${TRANSLATION_ANCILLARY_GROUP + groupList[0]}`);
	}

	openExtraBagsSidebar() {
		this.sidebarService.openSidebar(['checked-bags', { flight: this.flightIdentifier }]);
	}

	INDRA_showUpgrade() {
		//let brand = this.INDRA_printBrand();
		return !(this.brandDescription === BRAND_DESCRIPTION_TOP_EXECUTIVE || this.brandDescription === BRAND_DESCRIPTION_EXECUTIVE || this.hasDeporteeFlag || this.hasMedicalAssistanceFlag || this.hasUMNRFlag || this.IfAllPassengersAreChildren || !this.hasIssuedTicket) && !this.isFlagged;
	}

	INDRA_checkIndirectFlight() {
		const segments: string[] = this.bookingService.INDRA_getSegmentIDs(this.flightIdentifier);
		let flag = false;
		if (segments.length > 1) {
			flag = true;
		}
		return flag;
	}

	INDRA_checkIfSpecialCaseCountry() {
		const activeFare = this.bfmDataStorage.INDRA_getActiveBookedTrip().data.fare;
		const flightSegments = this.bookingService.INDRA_getBoundObject(this.flight,activeFare)
		let specialCaseCountries = this.locationService.INDRA_getSpecialCaseLocation(this.countryCodes, flightSegments, this.flightIdentifier);
		this.isUs = specialCaseCountries.includes(COUNTRY_CODE_USA);
	}

	INDRA_countExtraBags(list) {
		let count = 0;
		if (list && list.length > 0) {
			list.forEach(item => {
				if (item == SSR_CODE_BAGGAGE_ADDITIONAL_BAG) {
					count++;
				}
			})
			return count;
		}
		else {
			return count;
		}
	}


	INDRA_checkIfCodeShare() {
		return (this.bookingService.INDRA_checkIfCodeShare(this.flight.listSegment) ? true : false);
	}

	INDRA_upgradeWithCash() {
		let activeBookedTrip = this.bfmDataStorage.INDRA_getActiveBookedTrip();
		let link = '/my-bookings/upgrade-with-cash/' + activeBookedTrip.data.pnr;
		let params = { flight: this.flight.assignedFlightId }
		this.sidebarService.closeSidebar();
		this.bookingService.INDRA_linkRouteData(link, params);
	}

	INDRA_showAddButton() {
		const ancillaryAvailable = this.bookingService.INDRA_isAncillaryAvailable(EXTRAS_ANCILLARY_BAG, this.flightIdentifier);

		if (!ancillaryAvailable || !this.hasIssuedTicket) {
			this.showAddButton = false;
		}
	}

	INDRA_getPassengerTierLabel(pax: INDRAPax) {
		return this.bookingService.INDRA_getTierKeyLabel(pax);
	}

	ngOnDestroy() {
		if (this.totalSummarySubscription) this.totalSummarySubscription.unsubscribe();
	}
	
	INDRA_printImage() {
		const IMAGE = 'checked_baggage.jpg';
		return 'url(assets/images/ancillaries/includes/' + IMAGE + ')';
	}
	
	INDRA_getBrandDescription() {
		if (this.isBookingView || this.isReviewTTTCompletion) {
			if (!this.flight.fareFamily) return '';
			const brandCode = this.bookingSearchService.INDRA_getBrandCodeFromAmadeus(this.flight.fareFamily);
			return brandCode ? BRAND_NAMES_MAP[brandCode] : '';
		} else {
			this.bookingService.INDRA_getBrand(this.flightIdentifier.toString());
		}
	}

	public getCabinClass(){
		let maxWeightSpecs = this.flight.cabin === 'Economy' ? 'whatsIncludedSidebars.detailsLuggage.texts.maxWeightSpecs' : 'whatsIncludedSidebars.detailsLuggage.texts.maxWeightSpecsBusiness'; 
		let maxWeightSpecsText = this.INDRA_getTranslation(maxWeightSpecs);

		return maxWeightSpecsText;
	}

	public getBenefitText1SideBar() {
		let lang: string = (sessionStorage.getItem('language')).toLocaleLowerCase();
		let text: string;

		switch (lang) {
			case 'pt':
			case 'pt-br':
			case 'es':
			case 'fr':
			case 'it':
			case 'pl':
			case 'ru':
				text = 'whatsIncludedSidebars.detailsLuggage.text.isABenefitOf';
				break;
			case 'en':
			case 'en-us':
			case 'de':
			case 'zh':
			default:
				text = 'whatsIncludedSidebars.detailsLuggage.text.isA';
				break;
		}

		return text;
	}

	public getBenefitText2SideBar() {
		let lang: string = (sessionStorage.getItem('language')).toLocaleLowerCase();
		let text: string;

		switch (lang) {
			case 'pt':
			case 'pt-br':
			case 'es':
			case 'fr':
			case 'it':
			case 'pl':
			case 'ru':
				text = null;
				break;
			case 'en':
			case 'en-us':
			case 'de':
			case 'zh':
			default:
				text = 'whatsIncludedSidebars.detailsLuggage.text.benefit';
				break;
		}

		return text;
	}
}